import instObj from '@/backend/axios-instances'

const resource = "/masterproductions/step"
const instance = instObj.baseInstance

export default {
  get(masterProductionStepId, parameters) {
    return instance.get(`${resource}/${masterProductionStepId}`, { params: parameters });
  }
}
